import { Component } from '@angular/core';
import { PageShellComponent } from '../../core/layout/page-shell.component';
import { PromoHeroComponent } from './promo-hero.component';
import { PromoBannerComponent } from './promo-banner.component';
import { CurrentPromotionsComponent } from './current-promotions.component';
import { ReferralStepsComponent } from './referral-steps.component';
import { ProgramCardsComponent } from './program-cards.component';
import { ReferralFormComponent } from './referral-form.component';
import { FaqComponent } from './faq.component';

@Component({
  selector: 'hx-promotions-page',
  standalone: true,
  imports: [
    PageShellComponent,
    PromoHeroComponent,
    PromoBannerComponent,
    CurrentPromotionsComponent,
    ReferralStepsComponent,
    ProgramCardsComponent,
    ReferralFormComponent,
    FaqComponent,
  ],
  template: `
    <hx-page-shell>
      <hx-promo-hero></hx-promo-hero>
      <hx-promo-banner></hx-promo-banner>
      <hx-current-promotions></hx-current-promotions>
      <hx-referral-steps></hx-referral-steps>
      <hx-program-cards></hx-program-cards>
      <hx-referral-form></hx-referral-form>
      <hx-faq></hx-faq>
    </hx-page-shell>
  `,
})
export class PromotionsPageComponent {}
